//Global keys
let locales = {
    "management_menu": "Gestione"
};

//Merge Modules
import users from '../../users/.config/lan/it'
import companies from '../../companies/.config/lan/it'
import parameters from '../../parameters/.config/lan/it'
import campaigns from '../../campaigns/.config/lan/it'
import permissions from '../../permissions/.config/lan/it'
import roles from '../../roles/.config/lan/it'
import workFlowStatesModule from '../../workFlowStates/.config/lan/it'
import httplogs from '../../httpLogs/.config/lan/it'
import forms from '../../forms/.config/lan/it'
import reportCSV from '../../reportCSV/.config/lan/it'

locales = {
    ...locales,
    ...users,
    ...companies,
    ...parameters,
    ...campaigns,
    ...permissions,
    ...roles,
    ...workFlowStatesModule,
    ...httplogs,
    ...forms,
    ...reportCSV
};

export default locales;